import { RfcType } from '../../../types';

export type SapImportQueueStatus = 'PENDING' | 'RUNNING' | 'DONE' | 'FAILED';

export interface SapImportStatusData {
  id?: number;
  task_id?: string;
  run_id?: number | null;
  rfc_type?: RfcType | string;
  status?: SapImportQueueStatus;
  message?: string;
  error?: string | null;
  error_message?: string | null;
  started_at?: string | null;
  ended_at?: string | null;
  has_errors?: boolean;
}

export type SapImportStorageState = Record<string, SapImportStatusData>;

export const SAP_IMPORT_STORAGE_KEY = 'sap_import_status';
export const SAP_IMPORT_MESSAGE_TYPE = 'sap_import_status';
export const SAP_IMPORT_TERMINAL_STATUSES = ['DONE', 'FAILED'] as const;
